import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    AuthOnly,
    MembershipPricingTier,
    MembershipDetails,
    MembershipType
} from 'models';

@Injectable({
    providedIn: 'root'
})
export class MembershipService {
    constructor(private http: HttpClient) { }

    public createMembership(pricingTierId: number) {
        return this.http.post('api/membership/create', pricingTierId);
    }

    public getMembershipDetails(): Observable<MembershipDetails> {
        return this.http.get<MembershipDetails>('api/membership/details');
    }

    public getAuthOnly(custom: string, amount: number): Observable<AuthOnly> {
        return this.http.get<AuthOnly>(`api/acquired/getauthonly/${custom}/${amount}`);
    }

    public cancelMembership(membershipToMembershipPricingTierId) {
        return this.http.post('api/membership/cancel', membershipToMembershipPricingTierId);
    }

    public getPricingTiers(): Observable<MembershipPricingTier[]> {
        return this.http.get<MembershipPricingTier[]>('api/membership/pricingtiers');
    }

    public hasPaymentDetails(): Observable<boolean> {
        return this.http.get<boolean>(`api/acquired/haspaymentdetails/`);
    }
    public getPricingTierFromPromoCode(code: string, membershipType: MembershipType): Observable<MembershipPricingTier[] | string> {
        return this.http.get<MembershipPricingTier[] | string>(`api/membership/pricingtierbypromocode/${code}/${membershipType}`);
    }
}